import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    ScenarioDetails: {},
}

const ScenarioSlice = createSlice({
    name: "ScenarioSlice",
    initialState,

    reducers: {
        ScenarioData(state, action) {
            return {
                ScenarioDetails: action.payload.ScenarioDetails,
            };
        }
    }
})
export const { ScenarioData } = ScenarioSlice.actions;
export default ScenarioSlice.reducer;